import React from 'react';
import { buildClassName } from 'utils/build-class-name';
import { DesktopNavigation } from '@core/ui/navigation';
import type { NavigationModuleBehavior, NavigationButton } from '@core/ui/navigation';
import { useChat } from 'contexts';
import { openEqualWebMenu } from 'utils/accessibility';
import { zoocasaNavigationConfig } from 'tenants/zoocasa/config/navigation';
import styles from '../style.module.scss';

type MenuDropdownProps = {
  isCrawler: boolean;
  menuTrigger?: React.ReactNode;
};

const MenuDropdown = ({ isCrawler, menuTrigger }: MenuDropdownProps) => {
  const { openChat } = useChat();

  const handleNavigationAction = (handlerName: string) => {
    switch (handlerName) {
      case 'openAccessibilityMenu':
        openEqualWebMenu();
        break;
      case 'openChat':
        openChat({ source: 'Menu' });
        break;
      default:
        console.warn(`Unknown navigation action: ${handlerName}`);
    }
  };

  const menuItemBehavior: NavigationModuleBehavior = {
    ...zoocasaNavigationConfig.module.behavior,
    expandAllSubmenus: isCrawler,
  };

  const menuDropdownItems: NavigationButton[] = [
    {
      id: 'menu',
      buttonVariant: 'dropdown',
      label: 'Menu',
      ...(menuTrigger && { customTrigger: menuTrigger }),
      items: zoocasaNavigationConfig.structure.menu,
    },
  ];

  return (
    <DesktopNavigation 
      items={menuDropdownItems}
      behavior={menuItemBehavior}
      showChevron={false}
      onAction={handleNavigationAction}
      isCrawler={isCrawler}
      styleOverrides={{
        navButton: styles.noHoverNavButton,
        navigation: buildClassName(styles.menu, styles['nav-btn']),
      }}
    />
  );
};

export default MenuDropdown; 